import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  referralWrapper: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    width: "100%",
    backgroundColor: "#fafafa",
    "@media (max-width: 900px)": {
      flexDirection: "column"
    }
  },
  referralLeft: {
    flex: "0 0 45%",
    backgroundColor: "#ffffff",
    padding: "4rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxHeight: "100vh",
    overflowY: "hidden",
    "@media (max-width: 900px)": {
      display: "none"
    }
  },
  referralLogoContainer: {
    marginBottom: "20px",
    textAlign: "left"
  },
  referralLogo: {
    height: "35px"
  },
  referralIllustration: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px 0"
  },
  referralImg: {
    maxWidth: "420px",
    maxHeight: "100%",
    objectFit: "contain",
    "@media (max-width: 900px)": {
      maxHeight: "300px"
    }
  },
  referralLeftText: {
    marginTop: "auto",
    textAlign: "left",
    "& h1": {
      fontSize: "36px",
      fontWeight: 700,
      color: "#1a1a1a",
      margin: "0 0 10px 0",
      lineHeight: 1.2
    },
    "& p": {
      fontSize: "16px",
      color: "#666666",
      margin: 0
    }
  },
  referralRight: {
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "4rem 40px 4rem 40px",
    backgroundColor: "#fafafa",
    overflowY: "auto",
    "@media (max-width: 900px)": {
      padding: "4rem 20px 4rem 20px"
    }
  },
  referralFormCard: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "48px",
    width: "100%",
    maxWidth: "600px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    "@media (max-width: 900px)": {
      padding: "30px"
    }
  },
  referralFormHeader: {
    marginBottom: "32px",
    textAlign: "left",
    "& h2": {
      fontSize: "24px",
      fontWeight: 700,
      color: "#1a1a1a",
      margin: "0 0 8px 0"
    },
    "& p": {
      fontSize: "14px",
      color: "#666666",
      margin: 0
    }
  },
  inputGroupContainer: {
    marginBottom: "20px",
    textAlign: "left"
  },
  referralSelect: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    fontSize: "14px",
    color: "#1a1a1a",
    backgroundColor: "#ffffff",
    outline: "none",
    transition: "border-color 0.2s",
    appearance: "none",
    backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 16px center",
    backgroundSize: "16px",
    "&:focus": {
      borderColor: "#3b82f6"
    }
  },
  checkboxContainer: {
    margin: "32px 0 24px 0",
    textAlign: "left"
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "flex-start",
    cursor: "pointer",
    "& input[type='checkbox']": {
      marginTop: "4px",
      marginRight: "12px",
      cursor: "pointer"
    }
  },
  checkboxText: {
    fontSize: "14px",
    color: "#4a5568",
    lineHeight: 1.5,
    textAlign: "left"
  },
  submitButtonContainer: {
    marginTop: "24px",
    "& button": {
      width: "100%",
      padding: "14px",
      fontSize: "16px",
      fontWeight: 500
    }
  },
  howItWorksContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "30px",
    marginBottom: "40px",
    position: "relative"
  },
  howItWorksStep: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    flex: 1,
    padding: "0 10px",
    position: "relative",
    zIndex: 2
  },
  stepIconContainer: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#f0f6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    color: "#0065FF",
    fontSize: "24px"
  },
  stepTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "8px"
  },
  stepDescription: {
    fontSize: "12px",
    color: "#666666",
    lineHeight: 1.4
  },
  stepConnector: {
    position: "absolute",
    top: "24px",
    left: "50%",
    width: "100%",
    height: "20px",
    zIndex: 1,
    overflow: "hidden"
  },
  connectorSvg: {
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none"
  },
  formSection: {
    marginBottom: "24px",
    textAlign: "left"
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "4px"
  },
  sectionDescription: {
    fontSize: "12px",
    color: "#888888",
    marginBottom: "12px"
  },
  inputWithButton: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    padding: "4px",
    backgroundColor: "#ffffff",
    "&:focus-within": {
      borderColor: "#3b82f6"
    }
  },
  inputField: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "8px 12px",
    fontSize: "14px",
    color: "#666666",
    backgroundColor: "transparent"
  },
  copyButton: {
    backgroundColor: "#0065FF",
    color: "#ffffff",
    border: "none",
    borderRadius: "16px",
    padding: "6px 16px",
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    whiteSpace: "nowrap"
  },
  iconButton: {
    backgroundColor: "transparent",
    color: "#0065FF",
    border: "none",
    padding: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px"
  },
  sendIconButton: {
    backgroundColor: "#0065FF",
    color: "#ffffff",
    border: "none",
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginRight: "4px",
    fontSize: "14px"
  },
  footerText: {
    textAlign: "center",
    fontSize: "12px",
    color: "#888888",
    marginTop: "32px",
    "& a": {
      color: "#0065FF",
      textDecoration: "underline",
      fontWeight: 500
    }
  }
}));
